import { c as _c } from "react/compiler-runtime";
import { Card, Skeleton } from '@morpho-org/ui-v6/server';
import { ChartSkeleton } from '@repo/ui';
import { CHART_SKELETON_GEOMETRY } from '@/components/charts/components/ChartStatusLoading';

/** Mirrors VaultV2ApyClient: one card (chart + rate card) from `lg`, two stacked cards below. */
const VaultV2ApyLoading = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Card className="py-lg px-md lg:contents" withBorder={true}><div className="gap-lg flex min-w-[220px] grow flex-col"><div className="flex items-center justify-between"><div className="gap-xs flex flex-col"><div className="flex h-4 items-center"><Skeleton className="h-4 w-[60px]" /></div><Skeleton className="h-[44px] w-[111px] rounded-[20px]" /></div><Skeleton className="h-lg w-[90px] rounded-lg" /></div><ChartSkeleton className="h-[225px]" {...CHART_SKELETON_GEOMETRY} /></div></Card>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="gap-sm lg:gap-lg lg:border-border lg:bg-card lg:p-lg flex w-full flex-col lg:flex-row lg:rounded-[20px] lg:border-[0.5px] lg:shadow-md dark:lg:shadow-none">{t0}<Card padding="s" withBorder={true} className="flex-col lg:contents"><Skeleton className="h-[109px] w-full rounded-lg lg:h-auto lg:w-[275px] lg:rounded-[20px]" /></Card></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default VaultV2ApyLoading;